module.exports = __webpack_public_path__ + "img/information.3ed8d5e2.svg";